/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransactionType } from './TransactionType';
import {
    TransactionTypeFromJSON,
    TransactionTypeFromJSONTyped,
    TransactionTypeToJSON,
    TransactionTypeToJSONTyped,
} from './TransactionType';
import type { AccountCategory } from './AccountCategory';
import {
    AccountCategoryFromJSON,
    AccountCategoryFromJSONTyped,
    AccountCategoryToJSON,
    AccountCategoryToJSONTyped,
} from './AccountCategory';

/**
 * 
 * @export
 * @interface CreateTransactionCodeRequest
 */
export interface CreateTransactionCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionCodeRequest
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionCodeRequest
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTransactionCodeRequest
     */
    requiresClass: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTransactionCodeRequest
     */
    requiresAppointment: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTransactionCodeRequest
     */
    requiresBalanceApproval: boolean | null;
    /**
     * 
     * @type {TransactionType}
     * @memberof CreateTransactionCodeRequest
     */
    transactionType: TransactionType;
    /**
     * 
     * @type {AccountCategory}
     * @memberof CreateTransactionCodeRequest
     */
    category: AccountCategory;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTransactionCodeRequest
     */
    isCredit: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTransactionCodeRequest
     */
    isDebit: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTransactionCodeRequest
     */
    isDeferrable: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionCodeRequest
     */
    appliesToTransactionCode?: string | null;
}



/**
 * Check if a given object implements the CreateTransactionCodeRequest interface.
 */
export function instanceOfCreateTransactionCodeRequest(value: object): value is CreateTransactionCodeRequest {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('requiresClass' in value) || value['requiresClass'] === undefined) return false;
    if (!('requiresAppointment' in value) || value['requiresAppointment'] === undefined) return false;
    if (!('requiresBalanceApproval' in value) || value['requiresBalanceApproval'] === undefined) return false;
    if (!('transactionType' in value) || value['transactionType'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('isCredit' in value) || value['isCredit'] === undefined) return false;
    if (!('isDebit' in value) || value['isDebit'] === undefined) return false;
    if (!('isDeferrable' in value) || value['isDeferrable'] === undefined) return false;
    return true;
}

export function CreateTransactionCodeRequestFromJSON(json: any): CreateTransactionCodeRequest {
    return CreateTransactionCodeRequestFromJSONTyped(json, false);
}

export function CreateTransactionCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTransactionCodeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'requiresClass': json['requiresClass'],
        'requiresAppointment': json['requiresAppointment'],
        'requiresBalanceApproval': json['requiresBalanceApproval'],
        'transactionType': TransactionTypeFromJSON(json['transactionType']),
        'category': AccountCategoryFromJSON(json['category']),
        'isCredit': json['isCredit'],
        'isDebit': json['isDebit'],
        'isDeferrable': json['isDeferrable'],
        'appliesToTransactionCode': json['appliesToTransactionCode'] == null ? undefined : json['appliesToTransactionCode'],
    };
}

export function CreateTransactionCodeRequestToJSON(json: any): CreateTransactionCodeRequest {
    return CreateTransactionCodeRequestToJSONTyped(json, false);
}

export function CreateTransactionCodeRequestToJSONTyped(value?: CreateTransactionCodeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'requiresClass': value['requiresClass'],
        'requiresAppointment': value['requiresAppointment'],
        'requiresBalanceApproval': value['requiresBalanceApproval'],
        'transactionType': TransactionTypeToJSON(value['transactionType']),
        'category': AccountCategoryToJSON(value['category']),
        'isCredit': value['isCredit'],
        'isDebit': value['isDebit'],
        'isDeferrable': value['isDeferrable'],
        'appliesToTransactionCode': value['appliesToTransactionCode'],
    };
}

